import { render } from "./ControlPanel.vue?vue&type=template&id=7882278a&scoped=true&ts=true"
import script from "./ControlPanel.vue?vue&type=script&lang=ts"
export * from "./ControlPanel.vue?vue&type=script&lang=ts"

import "./ControlPanel.vue?vue&type=style&index=0&id=7882278a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7882278a"]])

export default __exports__